export class ExampleMasterCondition {
  input?: string;
  calendar?: string;
  dropdown?: string;
  autoCompleteCode?: string;
  inputNumber?: number;
  calendarRange?: string[];
  custValidation?: string;
  dynamicDropdown?: string;
  autoCompleteDropdownCode?: string;
}
